import React, {useState} from 'react'
import { Formik, Form } from 'formik'
import * as Yup from 'yup'
import FormikControl from '../SelectValue/FormikControl'
import Button from '../SelectValue/Button'
import Loading from '../SelectValue/Loading'
import postService from '../../Services/post-service'
import swal from 'sweetalert';
import Logo from '../../Assets/images/hlogo.png'
// import Constant from '../../Constant'
function ForgetPassForm() {
  const [loading, setLoading] = useState(false)
    const initialValues = { 
        email: '',
      }
      const validationSchema = Yup.object({
        email: Yup.string()
        .required('Email is required')
        .email('Invalid email format'),
      //  email:Yup
      //  .string()
      //  .email()
      //  .required('Please Enter your Email'),
      //  password: Yup.string()
      //  .required('Please Enter your password')
      //  .matches(
      //    Constant.passwordValidation,
      //    Constant.passwordValidationMessage
      //  ),
            
      })
      const onSubmit = values => {
        console.log('Form data', values)
        console.log('Saved data', JSON.parse(JSON.stringify(values)))
        setLoading(true)
        const {email} = values
        postService.forgetPassMail(email).then(
          (response) => {
              console.log(response.data)
              setLoading(false)
             if(response.data.status === '2000'){
               localStorage.setItem('frequestId', response.data.data.requestId)
                swal("Otp sent to your mail!").then(
                    res => {
                        return   window.location.href = '/comfirmpass'
                    }
                )
              // localStorage.setItem('token',response.data.data.token)
              
             }else{
              swal(response.data.description)
             
             }
             
            },
            (error) => {
              setLoading(false)
                return  swal('Network error')
                .then((value) => {
                  window.location.reload()
                });
              }
        )
        // navigate('/dashboard')
      }

  return (
    <div className=' bg-white shadow-lg p-16 rounded-[16px]'>
    <Loading
      open={loading}
    />
        <div className=' '>
        <img src={Logo} width='152' height='40' className=" "  alt=" logo" /> 
            <p className=' mt-6 text-[18px] text-back-color2 mb-5 md:text-[40px] font-[500]'>Forget password</p>
            <p className=' mt-3 text-[14px] text-back-color2 mb-5 md:text-[18px] font-[500]'>Enter your email address</p>
            <div className='  mt-5'>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}
                >
        {formik => (
        <Form>
            
               <FormikControl
                control='input'
                type='email'
                label='Email address'
                name='email'
              />  
             
              <div className=' grid grid-cols-1 mb-5 mt-6'>
              <Button
                name='Next'
              />
              </div>
              
              
        </Form>
        )}
            </Formik>
           
            </div>
        </div>
    </div>
  )
}

export default ForgetPassForm